import { PreviewAnomaly } from '@api/twin/AnomalyApi';
import PlaceholderImage from '@resources/icons/PlaceholderImage.svg';
import { Box } from '@stereograph/teia-system-design/components/Box';
import { MRT_Row } from '@stereograph/teia-system-design/components/Table';

interface ImageCellProps {
  row: MRT_Row<PreviewAnomaly>;
}

export const ImageCell = (props: ImageCellProps) => {
  const { row } = props;
  const src
    = row.original.snapshot
      ? `data:image/png;base64,${row.original.snapshot}`
      : PlaceholderImage;

  return (
    <Box
      sx={{
        width: '100%',
        height: 70,
        overflow: 'hidden',
        borderRadius: 2,
      }}
    >
      <img
        alt={row.original.title}
        src={src}
        loading="lazy"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
        }}
      />
    </Box>
  );
};
